// extracted by mini-css-extract-plugin
module.exports = {"no_x":"_3zZcwIJY24zAe_nNAcq8Sx","break_word":"GvWfHieSuvBnUO8tUcOO-"};